function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#fff16b;}.b{fill:#fdd44f;}.c{fill:#ffd321;}.d{fill:#98f9ff;}.e{fill:#002740;}.f{fill:#ff8e70;}.g{fill:#d0263d;}.h{fill:none;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0.01)"
}, React.createElement("path", {
  className: "a",
  d: "M294.38,40.74v6.768h8.336v.6a8.347,8.347,0,0,1-8.336,8.347v6.768a15.115,15.115,0,0,0,15.1-15.1V40.74Z",
  transform: "translate(-227.967 -35.349)"
}), React.createElement("path", {
  className: "b",
  d: "M294.38,40.74v6.768h8.336v.6a8.347,8.347,0,0,1-8.336,8.347v6.768a15.115,15.115,0,0,0,15.1-15.1V40.74Z",
  transform: "translate(-227.967 -35.349)"
}), React.createElement("path", {
  className: "b",
  d: "M150.68,40.74V48.1a15.115,15.115,0,0,0,15.1,15.1V56.437a8.347,8.347,0,0,1-8.347-8.336v-.593h8.347V40.74Z",
  transform: "translate(-116.686 -35.349)"
}), React.createElement("path", {
  className: "c",
  d: "M256,153.25h3.384v13.588H256Z",
  transform: "translate(-198.246 -122.476)"
}), React.createElement("path", {
  className: "d",
  d: "M337.94,350.42h39.268v32.663H337.94Z",
  transform: "translate(-261.7 -275.164)"
}), React.createElement("path", {
  className: "e",
  d: "M337.94,350.42h39.268v32.663H337.94Z",
  transform: "translate(-261.7 -275.164)"
}), React.createElement("path", {
  className: "f",
  d: "M0,374.6H39.269v27.208H0Z",
  transform: "translate(0 -293.889)"
}), React.createElement("path", {
  className: "g",
  d: "M144.07,263.56h50.5v52.259h-50.5Z",
  transform: "translate(-111.567 -207.9)"
}), React.createElement("path", {
  className: "b",
  d: "M82.42,21.583,87.205,16.8l4.785,4.783-4.785,4.783Z",
  transform: "translate(-63.826 -16.81)"
}), React.createElement("path", {
  className: "b",
  d: "M82.41,161.583l4.783-4.783,4.785,4.783-4.785,4.783Z",
  transform: "translate(-63.818 -125.226)"
}), React.createElement("path", {
  className: "b",
  d: "M22.43,91.583,27.213,86.8,32,91.583l-4.785,4.783Z",
  transform: "translate(-17.37 -71.018)"
}), React.createElement("path", {
  className: "a",
  d: "M387.1,21.625l4.785-4.785,4.785,4.785-4.785,4.783Z",
  transform: "translate(-299.769 -16.841)"
}), React.createElement("path", {
  className: "a",
  d: "M387.09,161.575l4.783-4.785,4.785,4.785-4.785,4.785Z",
  transform: "translate(-299.761 -125.218)"
}), React.createElement("path", {
  className: "a",
  d: "M447.08,91.575l4.785-4.785,4.785,4.785-4.785,4.785Z",
  transform: "translate(-346.217 -71.01)"
}), React.createElement("path", {
  className: "b",
  d: "M200.67,40.74V57.024a12.5,12.5,0,0,0,9.1,12.011v7.291h-3.384v6.768h13.536V76.327h-3.384V69.035a12.5,12.5,0,0,0,9.1-12.011V40.74Z",
  transform: "translate(-155.398 -35.349)"
}), React.createElement("path", {
  className: "h",
  d: "M302.716,71.336v-.6H294.38v8.932A8.347,8.347,0,0,0,302.716,71.336Z",
  transform: "translate(-227.967 -58.581)"
}), React.createElement("path", {
  className: "b",
  d: "M387.1,21.625l4.785-4.785,4.785,4.785-4.785,4.783Z",
  transform: "translate(-299.769 -16.841)"
}), React.createElement("path", {
  className: "b",
  d: "M387.09,161.575l4.783-4.785,4.785,4.785-4.785,4.785Z",
  transform: "translate(-299.761 -125.218)"
}), React.createElement("path", {
  className: "b",
  d: "M447.08,91.575l4.785-4.785,4.785,4.785-4.785,4.785Z",
  transform: "translate(-346.217 -71.01)"
}), React.createElement("path", {
  className: "h",
  d: "M302.716,71.336v-.6H294.38v8.932A8.347,8.347,0,0,0,302.716,71.336Z",
  transform: "translate(-227.967 -58.581)"
}));

var SvgPodium = function SvgPodium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 115.509,
    height: 107.929,
    viewBox: "0 0 115.509 107.929",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPodium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/podium.38959cd1.svg";
export { ForwardRef as ReactComponent };